var _a;
import { FilterPredicate } from "../FilterPredicate";
export var FilterFunctions = (_a = {},
    _a[FilterPredicate.Sport] = {
        collections: ["events", "markets", "leagues"],
        fn: "filterBySport"
    },
    _a[FilterPredicate.Date] = {
        collections: ["events", "markets"],
        fn: "filterBySportAndDate"
    },
    _a[FilterPredicate.LiveStreaming] = {
        collections: ["events"],
        fn: "filterByLiveStream"
    },
    _a[FilterPredicate.Favorites] = {
        collections: ["events"],
        fn: "filterByFavorites"
    },
    _a);
//# sourceMappingURL=FilterFunctions.js.map